import '../../assets/index24.css';var f = Object.defineProperty, w = Object.defineProperties;
var y = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var p = (a, r, o) => r in a ? f(a, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : a[r] = o, t = (a, r) => {
  for (var o in r || (r = {}))
    c.call(r, o) && p(a, o, r[o]);
  if (e)
    for (var o of e(r))
      u.call(r, o) && p(a, o, r[o]);
  return a;
}, i = (a, r) => w(a, y(r));
var g = (a, r) => {
  var o = {};
  for (var s in a)
    c.call(a, s) && r.indexOf(s) < 0 && (o[s] = a[s]);
  if (a != null && e)
    for (var s of e(a))
      r.indexOf(s) < 0 && u.call(a, s) && (o[s] = a[s]);
  return o;
};
import { jsx as _ } from "react/jsx-runtime";
import { forwardRef as P } from "react";
import { L as h } from "../../Loader-DVuQGvNU.js";
const I = "ProgressIndicator-module__root___tP4aD", L = "ProgressIndicator-module__bar___RpgyL", v = {
  root: I,
  bar: L
}, N = P(($, l) => {
  var n = $, {
    "data-plum-id": a,
    color: r = "violet",
    style: o,
    variant: s = "circular",
    value: d = 0
  } = n, m = g(n, [
    "data-plum-id",
    "color",
    "style",
    "variant",
    "value"
  ]);
  const b = r === "white" ? "var(--plum-white)" : r ? `var(--plum-${r}-6)` : void 0;
  return s === "linear" ? /* @__PURE__ */ _(
    "div",
    i(t({}, m), {
      ref: l,
      role: "progressbar",
      "aria-valuenow": d,
      "data-plum-id": a,
      className: v.bar,
      "data-color": r,
      style: i(t({}, o), {
        "--progress-value": `${d}%`,
        "--progress-background": r === "white" ? "var(--plum-gray-2)" : `var(--plum-${r}-2)`
      })
    })
  ) : /* @__PURE__ */ _(
    h,
    t({
      ref: l,
      classNames: v,
      "data-plum-id": a,
      style: i(t({}, o), {
        "--progress-indicator-color": b
      })
    }, m)
  );
});
N.displayName = "ProgressIndicator";
export {
  N as ProgressIndicator
};
